import type { JSX } from 'react';
import { AttachmentUpload } from './AttachmentUpload';
import { AttachmentList } from './AttachmentList';
import type { AttachmentsProps } from './attachment.types';

export const Attachments = ({
  source,
  caseComplaintId,
  attachments,
  isLoading,
  isUploading,
  disabled = false,
  onUpload,
  onDelete,
  onGetSignedUrl,
  onUpdateDescription,
}: AttachmentsProps): JSX.Element => (
  <div className='attachments-section'>
    {!disabled && (
      <div className='attachments-upload-col'>
        <AttachmentUpload
          source={source}
          caseComplaintId={caseComplaintId}
          isUploading={isUploading}
          disabled={disabled}
          onUpload={onUpload}
        />
      </div>
    )}
    <div className='attachments-list-col'>
      <AttachmentList
        attachments={attachments}
        isLoading={isLoading}
        disabled={disabled}
        onDelete={onDelete}
        onGetSignedUrl={onGetSignedUrl}
        onUpdateDescription={onUpdateDescription}
      />
    </div>
  </div>
);
